export default __webpack_public_path__ + "static/media/superscript.df620b2c.svg";